import * as React from 'react';
import { Link } from 'gatsby';
import { SamiroyTitle, SamiroyLogo } from '@samiroy/sprites';

type Props = {
  /** subtitle to show below the samiroy title */
  subtitle?: string;
};

const NavBar = ({ subtitle }: Props) => (
  <div className="boxed" style={{ display: 'flex', padding: '4px 12px', alignItems: 'center' }}>
    <div style={{ marginTop: 4, marginBottom: 4, display: 'inline-block' }}>
      <Link to="/" className="no-hover">
        <SamiroyTitle style={{ width: 127.5, height: 26.5 }} />
      </Link>
    </div>
    {subtitle && <div style={{ marginTop: 16 }}>&nbsp;➼&nbsp;{subtitle}</div>}
    <div style={{ marginLeft: 'auto' }}>
      <Link to="/" className="no-hover">
        <SamiroyLogo style={{ height: 28, width: 26 }} />
      </Link>
    </div>
  </div>
);

export default React.memo(NavBar);
